export const generateYAxesWithColors = (tags: any[]) => {
  if (tags.length === 0) return {};

  const yAxes: Record<string, any> = {};
  // eslint-disable-next-line @typescript-eslint/dot-notation
  yAxes['y'] = {
    type: 'linear',
    display: true,
    position: 'left',
    ticks: {
      color: tags[0]?.color,
    },
    grid: {
      drawOnChartArea: false,
    },
  };

  tags.slice(1).forEach((tag, index) => {
    const key = `y${index}`;

    yAxes[key] = {
      type: 'linear',
      display: true,
      position: 'left',
      ticks: {
        color: tag?.color,
      },
      grid: {
        drawOnChartArea: false,
      },
    };
  });

  return yAxes;
};
